import { render, staticRenderFns } from "./UploadedItemsList.vue?vue&type=template&id=465e22e5&"
import script from "./UploadedItemsList.vue?vue&type=script&lang=js&"
export * from "./UploadedItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports